import { PaywallCard as Root } from './PaywallCard';
import { PaywallCardActiveProjectsSelect } from './PaywallCardActiveProjectsSelect';
import { PaywallCardFeatures } from './PaywallCardFeatures';
import { PaywallCardHeader } from './PaywallCardHeader';
import { PaywallCardPlan } from './PaywallCardPlan';
import { PaywallCardPrice } from './PaywallCardPrice';
import { PaywallCardPricePerMonth } from './PaywallCardPricePerMonth';
import { PaywallCardSubmit } from './PaywallCardSubmit';
import { PaywallCardPlanText } from './PaywallCardPlanText';

export const PaywallCard = Object.assign(Root, {
  ActiveProjectsSelect: PaywallCardActiveProjectsSelect,
  Features: PaywallCardFeatures,
  Header: PaywallCardHeader,
  Price: PaywallCardPrice,
  Plan: PaywallCardPlan,
  Submit: PaywallCardSubmit,
  PricePerMonth: PaywallCardPricePerMonth,
  PlanText: PaywallCardPlanText,
});
